import {
  Button,
  Dialog,
  DialogClose,
  DialogContent,
  Typography,
} from '@growdash/design-system/atoms';
import { useOnboarding } from '@growdash/growintel/hooks/useOnboarding';

export default function TrendsOnboardingDialog() {
  const { isOnboarded, markAsOnboarded } = useOnboarding('trends');

  if (isOnboarded) return null;

  return (
    <Dialog
      defaultOpen
      onOpenChange={(open) => {
        if (!open) {
          markAsOnboarded();
        }
      }}
    >
      <DialogContent className="min-w-fit text-center">
        <Typography className="font-bold text-2xl">
          Start getting fresh insights ☕️
        </Typography>
        <Typography className="text-sm mt-6">
          Explore data from thousands of restaurants by selecting a cuisine and
          location - or add your own restaurant to
          <br />
          unlock tailored insights powered by Aisha.
        </Typography>
        <Typography className="text-sm mt-2 font-bold">
          Aisha will take care of everything for you.
        </Typography>
        <div className="mt-10">
          <DialogClose onClick={markAsOnboarded}>
            <Button>Start exploring</Button>
          </DialogClose>
        </div>
      </DialogContent>
    </Dialog>
  );
}
